import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { TooltipHost, DirectionalHint } from '@bingads-webui-react/fabric-control';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getInfoPaneItemCopyUrlStyle } from './styles/info-pane-item-copy-url-style';

const tooltipCalloutProps = { isBeakVisible: false, gapSpace: 10 };

const CopyUrlButton = ({ onClick, i18n, classes }) => {
  const [isURLCopied, setIsURLCopied] = useState(false);

  const onCopyUrlClick = useCallback(() => {
    setIsURLCopied(true);
    onClick();
  }, [onClick]);

  const onTooltipToggle = useCallback(isVisible => (!isVisible && setIsURLCopied(false)), []);

  return (
    <TooltipHost
      id="copyurl_tooltip"
      content={isURLCopied ? i18n.getString(_TL_('Copied to Clipboard')) : ''}
      directionalHint={DirectionalHint.bottomRightEdge}
      delay={500}
      closeDelay={500}
      calloutProps={tooltipCalloutProps}
      onTooltipToggle={onTooltipToggle}
    >
      <button aria-describedby="copyurl_tooltip" className={classes.copyUrl} onClick={onCopyUrlClick} >
        {i18n.getString(_TL_('Copy URL'))}
      </button>
    </TooltipHost>
  );
};

CopyUrlButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    copyUrl: PropTypes.string,
  }).isRequired,
};

export const InfoPaneItemCopyUrl = ({
  i18n,
  url,
  onCopy,
}) => {
  const classes = useDefaultStyles(getInfoPaneItemCopyUrlStyle);

  return (
    <div className={classes.contentItem}>
      <div className={classes.contentName}>{i18n.getString(_TL_('URL:'))}</div>
      <div className={classes.contentValue}>{url}</div>
      <CopyUrlButton onClick={onCopy} classes={classes} i18n={i18n} />
    </div>
  );
};

InfoPaneItemCopyUrl.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  url: PropTypes.string.isRequired,
  onCopy: PropTypes.func.isRequired,
};
